import { useCallback } from 'react';
import type { OnCommitStageSettings } from '../types';
type FitToScreenParamsT = {
  stageRef: React.RefObject<HTMLDivElement>;
  containerRef: React.RefObject<HTMLDivElement>;
  onCommitStageSettings: OnCommitStageSettings;
};
export function useFitToScreen({
  stageRef,
  containerRef,
  onCommitStageSettings
}: FitToScreenParamsT) {
  return useCallback(() => {
    const stage = stageRef.current;
    const container = containerRef.current;
    if (!stage || !container) return;
    const scale = Math.min(container.clientWidth / stage.clientWidth, container.clientHeight / stage.clientHeight);
    const x = container.offsetWidth / 2 - stage.clientWidth / 2;
    const y = container.offsetHeight / 2 - stage.clientHeight / 2;
    onCommitStageSettings({
      scale,
      x,
      y
    });
  }, [stageRef, containerRef, onCommitStageSettings]);
}